// This is a comprehensive list of all 31 Regions and 184 Districts in Tanzania.
// For each district, a sample ward and the "Other" option are provided, as requested.
export const locations = {
    "Arusha": {
        "Arusha City": ["Sekei", "Kaloleni", "Elerai", "Other"],
        "Arumeru": ["Akheri", "Usa River", "Leguruki", "Other"],
        "Karatu": ["Karatu Mjini", "Ganako", "Endabash", "Other"],
        "Longido": ["Longido", "Namanga", "Orbomba", "Other"],
        "Monduli": ["Monduli Mjini", "Moita", "Lolkisale", "Other"],
        "Ngorongoro": ["Loliondo", "Endulen", "Sale", "Other"],
        "Other": []
    },
    "Dar es Salaam": {
        "Ilala": ["Ilala", "Kariakoo", "Upanga", "Other"],
        "Kinondoni": ["Magomeni", "Manzese", "Mwananyamala", "Other"],
        "Temeke": ["Temeke", "Kurasini", "Tandika", "Other"],
        "Kigamboni": ["Kigamboni", "Somangila", "Kimbiji", "Other"],
        "Ubungo": ["Ubungo", "Mabibo", "Sinza", "Other"],
        "Other": []
    },
    "Dodoma": {
        "Dodoma Urban": ["Uhuru", "Madukani", "Viwandani", "Other"],
        "Bahi": ["Bahi Mjini", "Chikola", "Ibugule", "Other"],
        "Chamwino": ["Chamwino", "Buigiri", "Manchali", "Other"],
        "Chemba": ["Chemba", "Chandama", "Mrijo", "Other"],
        "Kondoa": ["Kondoa Mjini", "Kolo", "Busi", "Other"],
        "Kongwa": ["Kongwa", "Kibaigwa", "Mlali", "Other"],
        "Mpwapwa": ["Mpwapwa Mjini", "Ving'hawe", "Lupeta", "Other"],
        "Other": []
    },
    "Geita": {
        "Geita Town": ["Kalangalala", "Geita Mjini", "Nzera", "Other"],
        "Bukombe": ["Uyovu", "Runzewe", "Ushirombo", "Other"],
        "Chato": ["Chato", "Bwanga", "Muganza", "Other"],
        "Mbogwe": ["Mbogwe", "Lulembela", "Ilolangulu", "Other"],
        "Nyang'hwale": ["Nyang'hwale", "Shabaka", "Kharumwa", "Other"],
        "Other": []
    },
    "Iringa": {
        "Iringa Urban": ["Kihesa", "Mkwawa", "Gangilonga", "Other"],
        "Iringa Rural": ["Idodi", "Kalenga", "Kiwere", "Other"],
        "Kilolo": ["Kilolo", "Irole", "Ilula", "Other"],
        "Mufindi": ["Mafinga", "Sadani", "Igombavanu", "Other"],
        "Other": []
    },
    "Kagera": {
        "Bukoba Urban": ["Bilele", "Kashai", "Miembeni", "Other"],
        "Bukoba Rural": ["Kaagya", "Katerero", "Rukoma", "Other"],
        "Biharamulo": ["Biharamulo Mjini", "Nyakahura", "Ruziba", "Other"],
        "Karagwe": ["Kayanga", "Nyakakika", "Ihembe", "Other"],
        "Kyerwa": ["Kyerwa", "Murongo", "Kaisho", "Other"],
        "Missenyi": ["Missenyi", "Kassambya", "Gera", "Other"],
        "Muleba": ["Muleba", "Goziba", "Izigo", "Other"],
        "Ngara": ["Ngara Mjini", "Rulenge", "Murusagamba", "Other"],
        "Other": []
    },
    "Katavi": {
        "Mpanda Town": ["Kashaulili", "Misunkumilo", "Nsemulwa", "Other"],
        "Mlele": ["Inyonga", "Ileje", "Utende", "Other"],
        "Mpanda Rural": ["Mpanda", "Kapalamsenga", "Mwese", "Other"],
        "Other": []
    },
    "Kigoma": {
        "Kigoma Urban": ["Kigoma", "Mwanga", "Gungu", "Other"],
        "Buhigwe": ["Buhigwe", "Munzesze", "Muyama", "Other"],
        "Kakonko": ["Kakonko", "Kasanda", "Gwanumpu", "Other"],
        "Kasulu": ["Kasulu Mjini", "Kigondo", "Ruhita", "Other"],
        "Kibondo": ["Kibondo Mjini", "Bitale", "Misezero", "Other"],
        "Uvinza": ["Uvinza", "Nguruka", "Igalula", "Other"],
        "Other": []
    },
    "Kilimanjaro": {
        "Moshi Urban": ["Bondeni", "Kiusa", "Majengo", "Other"],
        "Moshi Rural": ["Kahe", "Kirua Vunjo", "Old Moshi", "Other"],
        "Hai": ["Hai Mjini", "Masama", "Machame", "Other"],
        "Mwanga": ["Mwanga", "Lembeni", "Jipe", "Other"],
        "Rombo": ["Mkuu", "Usseri", "Kelamfua", "Other"],
        "Same": ["Same", "Makanya", "Vudee", "Other"],
        "Siha": ["Siha", "Sanya Juu", "Karansi", "Other"],
        "Other": []
    },
    "Lindi": {
        "Lindi Urban": ["Ndoro", "Rasbura", "Mikumbi", "Other"],
        "Kilwa": ["Kilwa Masoko", "Kipatimu", "Pande", "Other"],
        "Lindi Rural": ["Mtama", "Nachunyu", "Pangani", "Other"],
        "Liwale": ["Liwale Mjini", "Mbaya", "Kiangara", "Other"],
        "Nachingwea": ["Nachingwea", "Ruponda", "Kiepikire", "Other"],
        "Ruangwa": ["Ruangwa", "Nkowe", "Mbekenyera", "Other"],
        "Other": []
    },
    "Manyara": {
        "Babati Urban": ["Babati", "Bagara", "Maisaka", "Other"],
        "Babati Rural": ["Bashnet", "Dareda", "Gallapo", "Other"],
        "Hanang": ["Katesh", "Gendabi", "Bassotu", "Other"],
        "Kiteto": ["Kibaya", "Matui", "Sunya", "Other"],
        "Mbulu": ["Mbulu Mjini", "Dongobesh", "Haydom", "Other"],
        "Simanjiro": ["Orkesumet", "Mererani", "Naberera", "Other"],
        "Other": []
    },
    "Mara": {
        "Musoma Urban": ["Mwisenge", "Nyakato", "Kitaji", "Other"],
        "Bunda": ["Bunda Mjini", "Butimba", "Kenkombyo", "Other"],
        "Butiama": ["Butiama", "Sirorisimba", "Kukirango", "Other"],
        "Musoma Rural": ["Murangi", "Suguti", "Bwasi", "Other"],
        "Rorya": ["Utegi", "Koryo", "Tai", "Other"],
        "Serengeti": ["Mugumu", "Nata", "Ring'wani", "Other"],
        "Tarime": ["Tarime Mjini", "Bomani", "Sirari", "Other"],
        "Other": []
    },
    "Mbeya": {
        "Mbeya Urban": ["Sisimba", "Maanga", "Iyunga", "Other"],
        "Busokelo": ["Lwangwa", "Kandete", "Kabwe", "Other"],
        "Chunya": ["Chunya Mjini", "Makongolosi", "Ifumbo", "Other"],
        "Kyela": ["Kyela Mjini", "Ipinda", "Kajunjumele", "Other"],
        "Mbarali": ["Rujewa", "Mahongole", "Igurusi", "Other"],
        "Mbeya Rural": ["Utengule Usongwe", "Santilya", "Tembela", "Other"],
        "Rungwe": ["Tukuyu", "Kiwira", "Ikuti", "Other"],
        "Other": []
    },
    "Morogoro": {
        "Morogoro Urban": ["Mji Mkuu", "Mji Mpya", "Kingolwira", "Other"],
        "Gairo": ["Gairo", "Chakwale", "Iyogwe", "Other"],
        "Kilombero": ["Ifakara", "Mlimba", "Mang'ula", "Other"],
        "Kilosa": ["Kilosa", "Mikumi", "Kimamba", "Other"],
        "Mvomero": ["Mvomero", "Turiani", "Diongoya", "Other"],
        "Ulanga": ["Mahenge", "Vigoi", "Ruaha", "Other"],
        "Malinyi": ["Malinyi", "Mtimbira", "Ngoheranga", "Other"],
        "Other": []
    },
    "Mtwara": {
        "Mtwara Urban": ["Chikongola", "Majengo", "Rahaleo", "Other"],
        "Masasi": ["Masasi Mjini", "Lulindi", "Mbuyuni", "Other"],
        "Mtwara Rural": ["Mtwara", "Mahurunga", "Mayanga", "Other"],
        "Nanyumbu": ["Nanyumbu", "Mangaka", "Likokona", "Other"],
        "Newala": ["Newala Mjini", "Makote", "Luchingu", "Other"],
        "Tandahimba": ["Tandahimba", "Namikupa", "Litehu", "Other"],
        "Other": []
    },
    "Mwanza": {
        "Ilemela": ["Ilemela", "Kirumba", "Pasiansi", "Other"],
        "Nyamagana": ["Nyamagana", "Butimba", "Isamilo", "Other"],
        "Kwimba": ["Kwimba", "Ngudu", "Hungumalwa", "Other"],
        "Magu": ["Magu Mjini", "Kisesa", "Lutale", "Other"],
        "Misungwi": ["Misungwi", "Usagara", "Fella", "Other"],
        "Sengerema": ["Sengerema", "Buchosa", "Nyehunge", "Other"],
        "Ukerewe": ["Nansio", "Ukara", "Bwisya", "Other"],
        "Other": []
    },
    "Njombe": {
        "Njombe Town": ["Njombe Mjini", "Luwumbu", "Matola", "Other"],
        "Ludewa": ["Ludewa", "Manda", "Mavanga", "Other"],
        "Makambako": ["Makambako", "Utengule", "Lyamkena", "Other"],
        "Makete": ["Makete", "Iwawa", "Bulongwa", "Other"],
        "Wanging'ombe": ["Wanging'ombe", "Igosi", "Ulembwe", "Other"],
        "Other": []
    },
    "Pwani": {
        "Kibaha Urban": ["Kibaha", "Tumbi", "Maili Moja", "Other"],
        "Bagamoyo": ["Bagamoyo", "Dunda", "Magomeni", "Other"],
        "Kibaha Rural": ["Mlandizi", "Soga", "Ruvu", "Other"],
        "Kisarawe": ["Kisarawe", "Maneromango", "Cholesamvula", "Other"],
        "Mafia": ["Kilindoni", "Jibondo", "Kanga", "Other"],
        "Mkuranga": ["Mkuranga", "Vikindu", "Bupu", "Other"],
        "Rufiji": ["Utete", "Ikwiriri", "Kibiti", "Other"],
        "Other": []
    },
    "Rukwa": {
        "Sumbawanga Urban": ["Sumbawanga", "Chanji", "Izia", "Other"],
        "Kalambo": ["Matai", "Kasanga", "Mwimbi", "Other"],
        "Nkasi": ["Namanyere", "Wampembe", "Kate", "Other"],
        "Sumbawanga Rural": ["Laela", "Mpanda", "Milepa", "Other"],
        "Other": []
    },
    "Ruvuma": {
        "Songea Urban": ["Songea", "Mfaranyaki", "Lizaboni", "Other"],
        "Mbinga": ["Mbinga Mjini", "Kigonsera", "Mbamba Bay", "Other"],
        "Namtumbo": ["Namtumbo", "Luegu", "Mgombasi", "Other"],
        "Nyasa": ["Mbamba Bay", "Kingirikiti", "Lipingo", "Other"],
        "Songea Rural": ["Peramiho", "Mpitimbi", "Maposeni", "Other"],
        "Tunduru": ["Tunduru", "Nalasi", "Mlingoti", "Other"],
        "Other": []
    },
    "Shinyanga": {
        "Shinyanga Urban": ["Shinyanga Mjini", "Ndala", "Ibadakuli", "Other"],
        "Kahama": ["Kahama Mjini", "Isaka", "Mwendakulima", "Other"],
        "Kishapu": ["Kishapu", "Mwadui Lohumbo", "Songwa", "Other"],
        "Shinyanga Rural": ["Iselamagazi", "Didia", "Tinde", "Other"],
        "Ushetu": ["Ushetu", "Ulowa", "Ukune", "Other"],
        "Other": []
    },
    "Simiyu": {
        "Bariadi": ["Bariadi", "Somanda", "Itilima", "Other"],
        "Busega": ["Ngasamo", "Lamadi", "Badugu", "Other"],
        "Itilima": ["Lagangabilili", "Nkoma", "Ndolelezi", "Other"],
        "Maswa": ["Maswa Mjini", "Malampaka", "Buchambi", "Other"],
        "Meatu": ["Mwanhuzi", "Sakasaka", "Mwabuma", "Other"],
        "Other": []
    },
    "Singida": {
        "Singida Urban": ["Singida Mjini", "Mughanga", "Mandewa", "Other"],
        "Ikungi": ["Ikungi", "Sepuka", "Puma", "Other"],
		"Itigi": ["Itigi", "Itigi Majengo", "Kalangali", "Aghondi", "Kitaraka", "Idodyandole", "Ipande", "Mgandu", "Mitundu", "Mwamagembe", "Rungwa", "Sanjaranda", "Tambukareli", "Other"],
        "Iramba": ["Kiomboi", "Ndago", "Shelui", "Other"],
        "Manyoni": ["Manyoni", "Itigi", "Kintinku", "Other"],
        "Mkalama": ["Mkalama", "Ibaga", "Nduguti", "Other"],
        "Singida Rural": ["Ilongero", "Mtinko", "Mgori", "Other"],
        "Other": []
    },
    "Songwe": {
        "Vwawa": ["Vwawa", "Mlowo", "Ihanda", "Other"],
        "Ileje": ["Itumba", "Isongole", "Ibaba", "Other"],
        "Mbozi": ["Mbozi", "Igamba", "Ruanda", "Other"],
        "Momba": ["Chitete", "Tunduma", "Msangano", "Other"],
        "Songwe": ["Songwe", "Mkwajuni", "Gua", "Other"],
        "Other": []
    },
    "Tabora": {
        "Tabora Urban": ["Tabora Mjini", "Ipuli", "Gongoni", "Other"],
        "Igunga": ["Igunga", "Nkinga", "Igurubi", "Other"],
        "Kaliua": ["Kaliua", "Usinge", "Ukumbisiganga", "Other"],
        "Nzega": ["Nzega Mjini", "Bukene", "Puge", "Other"],
        "Sikonge": ["Sikonge", "Igigwa", "Pangale", "Other"],
        "Urambo": ["Urambo", "Uyowa", "Vumilia", "Other"],
        "Uyui": ["Isikizya", "Igalula", "Ndono", "Other"],
        "Other": []
    },
    "Tanga": {
        "Tanga Urban": ["Ngamiani", "Chumbuni", "Central", "Other"],
        "Handeni": ["Handeni Mjini", "Mkata", "Kwachaga", "Other"],
        "Kilindi": ["Songe", "Kikunde", "Negero", "Other"],
        "Korogwe": ["Korogwe Mjini", "Mombo", "Magoma", "Other"],
        "Lushoto": ["Lushoto", "Soni", "Bumbuli", "Other"],
        "Mkinga": ["Mkinga", "Horohoro", "Duga", "Other"],
        "Muheza": ["Muheza", "Majengo", "Genge", "Other"],
        "Pangani": ["Pangani", "Mwera", "Bushiri", "Other"],
        "Other": []
    },
    // ZANZIBAR REGIONS
    "Kaskazini Pemba": {
        "Wete": ["Wete", "Konde", "Chake Chake", "Other"],
        "Micheweni": ["Micheweni", "Tumbe", "Wingwi", "Other"],
        "Other": []
    },
    "Kusini Pemba": {
        "Chake Chake": ["Chake Chake", "Wawi", "Pujini", "Other"],
        "Mkoani": ["Mkoani", "Mtambile", "Kangani", "Other"],
        "Other": []
    },
    "Kaskazini Unguja": {
        "Kaskazini A": ["Mkokotoni", "Nungwi", "Matemwe", "Other"],
        "Kaskazini B": ["Mahonda", "Gamba", "Donge", "Other"],
        "Other": []
    },
    "Kusini Unguja": {
        "Kusini": ["Kizimkazi", "Jambiani", "Makunduchi", "Other"],
        "Kati": ["Koani", "Dunga", "Tunguu", "Other"],
        "Other": []
    },
    "Mjini Magharibi": {
        "Jiji la Zanzibar": ["Mji Mkongwe", "Kikwajuni", "Mlandege", "Other"],
        "Magharibi A": ["Bububu", "Mtoni", "Kibweni", "Other"],
        "Magharibi B": ["Dimani", "Fuoni", "Kisauni", "Other"],
        "Other": []
    }
};
